import type { MessageDescriptor } from 'react-intl';

import { messages } from './messages';

const PARAMS_WHITELIST = ['dest_url', 'set_language', 'level', 'state'];

export function getWindowLoginOptions(
  loginOptions: Record<string, string> | null
): Record<string, string> {
  if (typeof window === 'undefined') return {};

  const { location } = window;
  const search = new URLSearchParams(location.search);

  return PARAMS_WHITELIST.reduce((acc, name) => {
    const value = search.get(name);

    if (value) acc[name] = value;

    return acc;
  }, loginOptions || {});
}

export function validateLogin(
  values: Record<string, string>
): Record<string, MessageDescriptor> {
  const { usernameRequiredError, passwordRequiredError } = messages;
  const { username, password } = values;

  const errors: Record<string, MessageDescriptor> = {};

  if (username.trim() === '') errors.username = usernameRequiredError;
  if (password.trim() === '') errors.password = passwordRequiredError;

  return errors;
}
